<template>
  <div class="menuMailWrap">
    <div class="titWrap">
      <div class="logo">
        <p class="copy">주문과 결제를 QR 스캔 하나로!</p>
        <div class="im">
          <div class='im'><img src='@/assets/img/mail/img_mail_bi_new.png'/></div>
        </div>
          <p class="tit">E-Receipt</p>
      </div>
      <ul class="btnArea">
          <li class="btn-print">
              <button @click="print" type="button" class="btn ">
                  <span>인쇄하기</span>
              </button>
          </li>
          <li class="btn-download">
              <button @click="createReceiptCanvasForEmail" type="button" class="btn btn-download">
                  <span>다운로드</span>
              </button>
          </li>
      </ul>
      <ReceiptComponent ref="receiptContent" @saveAsImage="createReceiptCanvasForEmail" :isOrderDetail="false" :receiptClass="receiptClass"/>
    </div>
  </div>

</template>

<script>
import ReceiptComponent from '@/components/Receipt/ReceiptComponent.vue';
import ReceiptMixins from '@/utils/ReceiptMixins';

export default {
  components: { ReceiptComponent },
  mixins: [ReceiptMixins],
  methods: {
    print () { window.print() }, // 인쇄하기 버튼 클릭
  }
}
</script>

<style lang="scss" scoped>

.btnArea{
    display:flex;
    gap: 1rem;
    max-width: 38.75rem;
    margin: 3rem auto 0 auto;

    li{
        padding: 1.6rem 0;
        flex: 1 1 50%;
        button{
            position: relative;
        }
        &.btn-print{
            background-color: #484848;
            span{
                color: #ffffff;
                padding-left: 2.2rem;
                font-size: 1.8rem;
                &::before{
                background: url('../assets/img/ic-24-receipt-print.svg');
                content: '';
                position: absolute;
                top: 50%;
                left: -1rem;
                transform: translateY(-50%);
                width: 2.4rem;
                height: 2.4rem;
                background-size: 2.4rem;
            }
            }
        }
        &.btn-download{
            background-color: var(--primary);
            span{
                color: #ffffff;
                padding-left: 2.2rem;
                font-size: 1.8rem;
                &::before{
                background: url('../assets/img/ic-24-receipt-download.svg');
                content: '';
                position: absolute;
                top: 50%;
                left: -1rem;
                transform: translateY(-50%);
                width: 2.4rem;
                height: 2.4rem;
                background-size: 2.4rem;
            }
            }
        }
    }
}

.menuMailWrap{
    .btnArea img{
        height: 5rem;
    }
    .btnArea li + li{
        margin-left: 0;
    }
}

.label-highlight {
    color: var(--primary) !important;
    font-size: 1.6rem !important;
    font-weight: bold !important;
}

</style>
